import H from 'constants/httpMethod.const';
import UMSG_TYPE from 'constants/umsg/type.const';
import logger from 'utils/logger.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

const L = logger('beAccountManager'); // eslint-disable-line no-unused-vars

const fromDtoToAccountManager = (dto) => ({
  name: dto?.results?.name,
  profileImageUrl: dto?.results?.profile_image_url,
  link: dto?.results?.link,
});

export const ibeAccountManagerRead = actionEndpointBe('ibeAccountManagerRead', H.get, 'salon/v2/:salonId/account_manager/', (options) => ({
  ...options,
  inert: true,
  umsg: UMSG_TYPE.global,
  fromDto: fromDtoToAccountManager,
}));
